import { useEffect } from 'react';
import LoginIframe from './LoginIframe';
import setPath from '@/lib/setPath';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { query as querySelector } from '@/redux/selectors/querySelectors.js';

const GoToMindCloudScreen = () => {
  const isIframe = window.self !== window.top;
  const query = useArgSelector(querySelector);
  const title = query?.title ? decodeURIComponent(query.title.replace(/\+/g, ' ')) : 'Please access the MindCloud dashboard to manage your integrations';
  const message = query?.message ? decodeURIComponent(query.message.replace(/\+/g, ' ')) : 'Click on Continue to access the MindCloud dashboard';

  useEffect(() => {
    if (!isIframe) {
      setPath('/');
    }
  }, [isIframe]);

  return <LoginIframe title={title} message={message} />;
};

export default GoToMindCloudScreen;
